export default __webpack_public_path__ + "static/media/panTech3Full.5231bc7d.png";